window.middysHawkSearchTemplates = window.middysHawkSearchTemplates || {};
window.middysHawkSearchTemplates.facetsList = `
    <style>
        .product-filters {
            margin-right: 18px;
            width: 286px;
            padding-top: 31px;
        }

        .flex-center-space-between {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: space-between;
        }

        .sidebar-head label {
            font-weight: 700;
            font-size: 16px;
            line-height: 28px;
            letter-spacing: .01em;
            color: #2f2f2f;
        }

        .sidebar-head {
            padding: 4px 0;
            border-bottom: .5px solid #d1d5db;
        }

        /* Injected on mobile by hawksearchProductListing; global .close-filter does not pierce shadow. */
        .close-filter {
            display: none;
            width: 14px;
            height: 14px;
            background: url(/images/close-icon-pink.svg) no-repeat center / contain;
        }

        .clear-filter {
            text-decoration: none;
            font-size: 14px;
            line-height: 28px;
            letter-spacing: .01em;
            color: #2f2f2f;
            padding-left: 27px;
            background: url(/images/refresh-icon.svg) no-repeat left center;
        }

        a.clear-filter:hover {
            color: #E6007E !important;
        }

        @media screen and (max-width: 767px), print {
            .sidebar-head {
                border-bottom: 0;
                margin-bottom: 16px;
            }

            .sidebar-head label {
                line-height: 24px;
                color: #e6007e;
                padding-right: 16px;
            }

            .close-filter {
                display: block;
            }

            .clear-filter {
                width: 100%;
                margin-top: 24px;
            }
        }

        .open-filter .filter-link {
            background: url(/images/arrow-up-grey.svg) no-repeat right center;
        }

        .filter-block.open-filter > ul {
            display: block;
        }

        .filter-link {
            display: block;
            font-size: 16px;
            line-height: 29px;
            letter-spacing: .15px;
            color: #2f2f2f;
            padding: 10px 20px 10px 0;
            background: url(/images/arrow-down-grey.svg) no-repeat right center;
        }

        ul.parent-category {
            padding-left: 0;
            max-height: 490px;
            overflow: hidden;
            overflow-y: auto;
        }

        ul {
            display: none;
            padding-left: 18px;
            margin: 10px 0;
            list-style-type: none;
        }

        ul li {
            position: relative;
            margin-bottom: 20px;
        }

        .product-filters .filter-block input[type=checkbox]:checked+label {
            font-weight: 600;
        }

        input[type=checkbox]:checked+label {
            transition: all .3s ease;
            background: url(/images/checkbox-selected.svg) no-repeat left top;
        }

        input[type=checkbox]+label {
            font-family: Lato;
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 18px;
            min-height: 18px;
            display: inline-block;
            letter-spacing: .02em;
            color: #464343;
            padding-left: 30px;
            background: url(/images/checkbox-unselected.svg) no-repeat left top;
            transition: all .3s ease;
        }

        input[type=checkbox]:checked+label {
            font-weight: 600;
        }

        :host, :root {
            --color-accent: '';
            --color-background: '';
            --form-element-border: '';
        }
    </style>
    <div>
        <div class="sidebar-head flex-center-space-between">
            <label>Filters</label>
            <a href="#" class="close-filter"></a>
            <a href="#" class="clear-filter" onClick="hawksearchProductListing.clearFilters(event)">Clear all filters</a>
        </div>
        <div>
            {{#each facets}}
            <hawksearch-facet-wrapper hawksearch-facet-id="{{id}}"></hawksearch-facet-wrapper>
            {{/each}}
            <div class="filter-block">
                <span class="filter-link" onclick="hawksearchProductListing.toggleFilterFacet(event); return false;">Availability</span>
                <ul class="parent-category">
                    <li>
                        <input type="checkbox" id="excludeOutOfStock" value="true" />
                        <label class="cat-label" for="excludeOutOfStock">
                            <span>In Stock Only</span>
                        </label>
                    </li>
                </ul>
            </div>
        </div>
    </div>
`;
